import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AppToast.css";

export default function AppToastContainer() {
    return (
        <ToastContainer
            position="bottom-right"
            autoClose={2000}
            hideProgressBar
            newestOnTop
            closeOnClick
            pauseOnFocusLoss={false}
            draggable={false}
            limit={3}
            className="app-toast-container"
            toastClassName="app-toast"
            bodyClassName="app-toast-body"
            progressClassName="app-toast-progress"
        />
    );
}
